// require instead of import because TypeScript doesn't like importing files outside of rootDir
// eslint-disable-next-line @typescript-eslint/no-var-requires
const lernaConfig = require('../../../../lerna.json');

export const VERSION = lernaConfig.version;
